import { STATUS_CLS, statusLabel } from "./view";

export const StatusBadge = ({ status, meta }) => (
    <span className={`st st-${STATUS_CLS[status] || "new"}`}>{statusLabel(meta, status)}</span>
);

export const ChannelBadge = ({ channel }) =>
    channel === "phone"
        ? <span className="ch ch-tel"><i className="fa-solid fa-phone"></i>전화</span>
        : <span className="ch ch-bot"><i className="fa-regular fa-comment-dots"></i>챗봇</span>;

export const Soon = ({ title = "서버 연동 후 사용할 수 있습니다" }) => (
    <span className="pill-soon" title={title}><i className="fa-solid fa-circle"></i>연동 예정</span>
);
